module.exports = __webpack_public_path__ + "img/icon_blue-small_ticket.4e0a0e15.svg";